import React, { useMemo } from "react";
import MotifNav from "@ey/canvascoreservices/MotifNav";
import styled from "styled-components";
import MotifTextLink from "@ey/motif-react-wrapper/TextLink";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirHelpCircle } from "@ey-xd/motif-icon";
import { Environment } from "../../../util";

const TopNavigation: React.FC = () => {
  const helpUrl = useMemo(() => {
    return Environment.getHelpUrl();
  }, []);

  const helpIcon = () => {
    return (
      <MotifTextLink href={helpUrl} target="_blank">
        <MotifIcon className="help-icon-wrap" src={IconoirHelpCircle} size="24" />
      </MotifTextLink>
    );
  };

  return (
    <StyledMotifNav>
      <MotifNav
        applicationName={""}
        applicationNameRedirectUrl={""}
        disableLogo={false}
        showIconLinks={false}
        showAvatar={false}
        showNotifications={false}
        showMoreMenuOptions={false}
        showSelectorDropdown={false}
        showSettings={false}
        showSearchBox={false}
        showAIChatbot={false}
        showHelpIcon
        helpIcon={helpIcon}
      />
    </StyledMotifNav>
  );
};

export default TopNavigation;

const StyledMotifNav = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  .motif-header-left .motif-header-logo .motif-icon svg path:nth-child(3) {
    stroke: none;
    fill: var(--logo-ey-accent) !important;
  }

  .help-icon-wrap.help-icon-wrap {
    color: var(--neutrals-900);
    svg {
      path {
        fill: var(--neutrals-900) !important;
      }
    }
  }
`;
